module.exports = __webpack_public_path__ + "img/logo_column.248206d8.svg";